const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrafficSituation2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 394.498 250.959 C 394.498 326.306 349.101 371.367 301.685 418.328 C 273.029 445.744 245.406 474.136 217.735 502.521 C 190.112 474.136 162.441 445.744 133.784 418.328 C 86.417 371.367 40.233 326.306 40.233 250.959 C 40.233 227.977 44.817 205.219 53.724 183.989 C 62.631 162.757 75.689 143.465 92.149 127.216 C 108.61 110.963 128.147 98.075 149.654 89.277 C 171.161 80.483 194.209 75.956 217.489 75.956 C 240.763 75.956 263.812 80.483 285.319 89.277 C 306.826 98.075 326.367 110.963 342.822 127.216 C 359.283 143.465 372.341 162.757 381.248 183.989 C 390.155 205.219 394.744 227.977 394.744 250.959 L 394.498 250.959 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.985,
    cy: 147.787,
    r: 34,
    fill: "#FBE415",
    stroke: "#231F20",
    strokeWidth: 4,
    style: {},
    transform: "matrix(3.928674, 0, 0, 4.261617, -479.629181, -372.860809)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(35, 31, 32)"
    },
    cx: 216.477,
    cy: 316.793,
    rx: 17.247,
    ry: 19.586
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)"
    },
    d: "M 194.362 168.237 L 207.606 279.598 L 225.776 279.602 L 236.16 168.237 L 194.362 168.237 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficSituation2);
export default __webpack_public_path__ + "static/media/trafficSituation2.78ef4393a8fc330c9db28ad3082c00c8.svg";
export { ForwardRef as ReactComponent };